import styled from 'styled-components';
import theme from '../theme'
import { RelSize, Ratio } from '../mixins'
import { darken, lighten } from 'polished';

export const FormRow = styled.div`
    margin-bottom: ${props => props.flush ? 0 : RelSize(20, 16)};
    text-align: ${props => props.align ? props.align : "left"};
    ${props => props.above && `
        z-index: 5;
    `};
    width: 100%;
    input, textarea {
        background-color: ${theme.white};
        border: ${props => props.hasError ? `1px solid ${theme.red}` : `1px solid ${theme.borderGrey}`};
        display: block;
        font-size: 16px;
		line-height: ${RelSize(21, 16)};
        padding: ${RelSize(15, 16)};
        width: 100%;
        &:active, &:focus {
            box-shadow: none;
            outline: none;
        }
        &[type="date"]::-webkit-inner-spin-button {
            display: none;
            -webkit-appearance: none;
        }
    }
    textarea {
        min-height: ${RelSize(145, 16)};
    }
    input[type="file"] {
        cursor: pointer;
        padding: ${RelSize(13, 16)};
        opacity: 0;
		width: 100%;
    }
	& + & {
		${props => props.divide && `
			border-top: 1px solid ${theme.borderGrey};
			padding-top: ${RelSize(30, 16)};
		`}
	}
`;

export const CodeFormRow = styled.div`
	> div {
		display: flex !important;
		> input {
			font-size: 30px !important;
			height: auto !important;
			line-height: 40px !important;
			padding: 10px 5px !important;
			text-align: center !important;
			width: 16.666666666666667% !important;
		}
	}
`;

export const FormRowInner = styled.div`
    ${props => props.alternative && `
        align-items: center;
        display: flex;
        justify-content: center;
    `}
    position: relative;
    input {
      background-color: ${theme.white};
      border: 1px solid ${theme.borderGrey};
    }
    text-align: ${props => props.align ? props.align : "left"};
    ${props => props.inline && `
        @media all and (min-width: 769px) {
            align-items: center;
            display: flex;
            flex-wrap: wrap;
            label {
                padding-right: ${RelSize(20, 16)};
                margin-bottom: 0;
                min-width: ${RelSize(150, 16)};
                max-width: ${RelSize(150, 16)};
                text-align: right;
                width: 100%;
            }
            input, select {
                flex: 1;
            }
        }
    `}
    ${props => props.full && `
        padding-left: ${RelSize(50, 16)};
    `}
    ${props => props.search && `
        input {
            padding-right: ${RelSize(75, 16)};
        }
    `}
	${props => !props.readonly && props.type === "tel" && `
		input {
			padding-right: ${RelSize(50, 16)};
		}
	`}
	${props => !props.readonly && props.type === "email" && `
		input {
			background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDI0IDE4Ij4KICA8cGF0aCBpZD0iaWNvbm1vbnN0ci1lbWFpbC0yIiBkPSJNMCwzVjIxSDI0VjNabTYuNjIzLDcuOTI5TDIsMTYuNjQxVjcuMTgzbDQuNjIzLDMuNzQ2Wk0yLjQ4Miw1SDIxLjUxN0wxMiwxMi43MTMsMi40ODIsNVptNS42OTQsNy4xODhMMTIsMTUuMjg3bDMuODMtMy4xTDIxLjQ0MiwxOUgyLjY2M1ptOS4yMDgtMS4yNjRMMjIsNy4xODN2OS4zNDhsLTQuNjE2LTUuNjA3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMykiIGZpbGw9IiMxNDE0MTQiLz4KPC9zdmc+Cg==');
			background-size: 12px 9px;
			background-position: right 10px top 50%;
			background-repeat: no-repeat;
			padding-right: ${RelSize(40, 16)};
		}
	`}
	${props => !props.readonly && props.type === "tel" && `
		input {
			background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDE4IDI0Ij4KICA8cGF0aCBpZD0iaWNvbm1vbnN0ci1waG9uZS0zIiBkPSJNMTguNDgsMjIuOTI2bC0xLjE5My42NThDMTAuMzA4LDI3LjItMS44LDYuMDksNS4wMDgsMi4xbDEuMTQ1LS42MzdMOS44NjcsNy45M2wtMS4xMzkuNjMyYy0yLjA2NywxLjI0NSwyLjc2LDkuNzA3LDQuODc5LDguNTQ1bDEuMTYyLS42NDIsMy43MTEsNi40NjFaTTguNjcyLDAsNi45OTIuOTc1bDMuNzE0LDYuNDY2LDEuNjgxLS45NzVabTguNjEzLDE1LTEuNjguOTc1LDMuNzE0LDYuNDY3TDIxLDIxLjQ2NCwxNy4yODUsMTVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMykiIGZpbGw9IiMxNDE0MTQiLz4KPC9zdmc+Cg==');
			background-size: 9px 12px;
			background-position: right 10px top 50%;
			background-repeat: no-repeat;
			padding-right: ${RelSize(40, 16)};
		}
	`}
	${props => !props.readonly && props.type === "currency" && `
		input {
			background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIg0KCSBpZD0ic3ZnMiIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnNvZGlwb2RpPSJodHRwOi8vc29kaXBvZGkuc291cmNlZm9yZ2UubmV0L0RURC9zb2RpcG9kaS0wLmR0ZCIgeG1sbnM6aW5rc2NhcGU9Imh0dHA6Ly93d3cuaW5rc2NhcGUub3JnL25hbWVzcGFjZXMvaW5rc2NhcGUiIHNvZGlwb2RpOmRvY25hbWU9ImdicC5zdmciIGlua3NjYXBlOnZlcnNpb249IjAuNDguNCByOTkzOSINCgkgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMjAwcHgiIGhlaWdodD0iMTIwMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMTIwMCAxMjAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxMjAwIDEyMDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHNvZGlwb2RpOm5hbWVkdmlldyAgaW5rc2NhcGU6Y3k9Ijc4Ni4yMTYxNyIgaW5rc2NhcGU6Y3g9Ii04NjQuNjE1NzEiIGlua3NjYXBlOnpvb209IjAuMTc1IiBzaG93Z3JpZD0iZmFsc2UiIGlkPSJiYXNlIiBib3JkZXJvcGFjaXR5PSIxLjAiIGJvcmRlcmNvbG9yPSIjNjY2NjY2IiBwYWdlY29sb3I9IiNmZmZmZmYiIGlua3NjYXBlOmN1cnJlbnQtbGF5ZXI9ImxheWVyMSIgaW5rc2NhcGU6d2luZG93LW1heGltaXplZD0iMSIgaW5rc2NhcGU6d2luZG93LXk9IjI0IiBpbmtzY2FwZTp3aW5kb3ctaGVpZ2h0PSI4NzYiIGlua3NjYXBlOndpbmRvdy13aWR0aD0iMTUzNSIgaW5rc2NhcGU6cGFnZXNoYWRvdz0iMiIgaW5rc2NhcGU6cGFnZW9wYWNpdHk9IjAuMCIgaW5rc2NhcGU6d2luZG93LXg9IjY1IiBpbmtzY2FwZTpkb2N1bWVudC11bml0cz0icHgiPg0KCTwvc29kaXBvZGk6bmFtZWR2aWV3Pg0KPGcgaWQ9ImxheWVyMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCwxNDcuNjM3ODIpIiBpbmtzY2FwZTpsYWJlbD0iTGF5ZXIgMSIgaW5rc2NhcGU6Z3JvdXBtb2RlPSJsYXllciI+DQoJPGcgaWQ9InRleHQyOTkzIj4NCgkJPHBhdGggaWQ9InBhdGgzMDM5IiBkPSJNNjc2LjA2Mi0xNDcuNjM4YzEwNS4xOTEsMC4wMDEsMjEwLjM4MywyMi4xMTksMzE1LjU3Niw2Ni4zNTJsLTc1LjI1MywxODYuMTA5DQoJCQlDODMxLjY5MSw3MC4zLDc1OC4zMjcsNTMuMDM3LDY5Ni4yOTEsNTMuMDM2Yy00Mi4wNzcsMC4wMDEtNzQuNDQ0LDEyLjEzOS05Ny4xMDEsMzYuNDEzDQoJCQljLTIyLjY1NywyMy43MzctMzMuOTg1LDU3Ljk5Mi0zMy45ODQsMTAyLjc2NXYxNTYuMTdoMzAzLjQzOHYxNzcuMjA5SDU2NS4yMDZ2MTE1LjcxMQ0KCQkJYy0wLjAwMSw5MS43MDYtNDAuNzI5LDE1OC41OTgtMTIyLjE4NiwyMDAuNjc0aDU4MC45ODV2MjEwLjM4NUgxNzUuOTk0Vjg1MS42ODhjNTUuNTYzLTIzLjczNSw5My41OTQtNTAuOTc4LDExNC4wOTMtODEuNzI3DQoJCQljMjEuMDM5LTMwLjc0OCwzMS41NTgtNzMuMDk1LDMxLjU1OS0xMjcuMDRWNTI1LjU5M0gxNzcuNjEyVjM0OC4zODRoMTQ0LjAzM1YxOTAuNTk2DQoJCQlDMzIxLjY0NSw4Mi4xNjgsMzUyLjM5NC0xLjE3Nyw0MTMuODkxLTU5LjQzOEM0NzUuOTI3LTExOC4yMzcsNTYzLjMxNy0xNDcuNjM3LDY3Ni4wNjItMTQ3LjYzOCIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K');
			background-size: 9px 12px;
			background-position: left 10px top 50%;
			background-repeat: no-repeat;
			padding-left: ${RelSize(30, 16)};
		}
	`}
	.chrome-picker {
		width: 100% !important;
	}
	.mentions {
		.mentions__control {
			min-height: ${RelSize(120, 16)};
			textarea {
				min-height: ${RelSize(120, 16)};
			}
		}
		.mentions__suggestions {
			background-color: ${theme.quarterinaryGreen} !important;
			border-radius: ${RelSize(5, 16)} !important;
			box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
			overflow: hidden;
			max-height: ${RelSize(200, 16)};
			padding-left: ${RelSize(10, 16)} !important;
			padding-right: ${RelSize(15, 16)} !important;
			overflow-y: auto;
			scrollbar-width: thin;
			scrollbar-color: ${theme.primaryGreen} transparent;
			&::-webkit-scrollbar {
			width: 5px;
			}
			&::-webkit-scrollbar-track {
			background: transparent;
			}
			&::-webkit-scrollbar-thumb {
			background: ${theme.primaryGreen};
			}
			ul {
				background-color: ${theme.quarterinaryGreen};
				margin: 0;
				padding: ${RelSize(5, 16)} 0 !important;
				li {
					color: ${theme.white};
					font-size: ${RelSize(12, 16)};
					font-weight: 700;
					padding: ${RelSize(5, 12)} ${RelSize(10, 12)};
				}
			}
			&__item {
				&--focused {
					background-color: rgba(255, 255, 255, 0.2);
					border-radius: 5px;
				}
			}
		}
		&__highlighter {
			font-size: 16px;
			line-height: ${RelSize(21, 16)};
			min-height: ${RelSize(120, 16)};
			padding: ${RelSize(15, 16)};
		}
		&__highlight {
			background-color: ${theme.quarterinaryGreen};
			border-radius: 5px;
			padding: 2px;
			opacity: 0.5;
		}
	}
`;

export const SwitchContainer = styled.div`
	align-items: flex-start;
    display: flex;
	flex-direction: ${props => props.inline ? "row" : "column"};
	justify-content: flex-start;
    width: 100%;
	> label {
		${props => props.inline && `
			padding-right: ${RelSize(20, 16)};
		`}
	}
`;

export const Label = styled.label`
    color: ${theme.primaryGreen};
    display: block;
    font-size: ${RelSize(16, 16)};
    font-weight: 700;
    left: 0;
    line-height: ${RelSize(21, 16)};
    margin: 0 0 ${props => props.isTitle ? RelSize(20, 16) : RelSize(10, 16)};
    padding: 0 ${props => props.help ? RelSize(25, 16) : 0} 0 0;
    position: relative;
    text-align: left;
    ${props => props.alternative && `
        color: ${theme.white};
        max-width: none;
        white-space: nowrap;
        width: auto;
    `};
    a {
        color: ${theme.black};
        font-weight: 700;
    }
	span {
		font-size: ${RelSize(12, 16)};
		font-weight: 200;
		margin-left: ${RelSize(10, 12)};
		+ span {
			padding-lefT: ${RelSize(10, 12)};
			position: relative;
			&::before {
				background-color: ${props => props.theme.black};
				bottom: 0;
				content: "";
				left: 0;
				position: absolute;
				top: 0;
				width: 1px;
			}
		}
	}
    ${props => props.full && `
        form & {
            max-width: none !important ;
            text-align: left !important;
        }
    `}
`;

export const SwitchWrapper = styled.div`
    height: ${RelSize(20, 16)};
    position: relative;
    width: ${RelSize(40, 16)};
`;

export const SwitchSubContainer = styled.div`
	align-items: center;
	display: flex;
	span {
		color: ${props => props.readonly ? lighten(0.7, props.theme.black) : props.theme.black};
		font-size: ${RelSize(12, 16)};
		max-width: ${RelSize(100, 16)};
	}
	${SwitchWrapper} {
		margin: 0 ${RelSize(10, 16)};
	}
	a {
		color: ${props => props.theme.black};
		font-size: ${RelSize(12, 16)};
		margin-left: ${RelSize(15, 12)};
	}
`;

export const SwitchLabel = styled.label`
    position: absolute;
    top: 50%;
    left: 0;
    width: ${RelSize(40, 16)};
    height: ${RelSize(20, 16)};
    border-radius: ${RelSize(30, 16)};
    background: ${props => props.readonly ? lighten(0.5, props.theme.primaryGreen) : props.theme.primaryGreen};
    cursor: pointer;
    transform: translateY(-50%);
    &::after {
        content: "";
        display: block;
        border-radius: ${RelSize(10, 16)};
        width: ${RelSize(20, 16)};
        height: ${RelSize(12, 16)};
        margin: 4px;
        background: ${props => props.theme.quarterinaryGreen};
        box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
        transition: 0.2s;
    }
`;

export const SwitchInput = styled.input`
    opacity: 0;
    z-index: 1;
    top: 50%;
    left: 0;
    border-radius: 15px;
    width: ${RelSize(40, 16)};
    height: ${RelSize(20, 16)};
    transform: translateY(-50%);
	position: absolute;
	cursor: pointer;
    &:checked + ${SwitchLabel} {
        &::after {
            content: "";
            display: block;
            border-radius: ${RelSize(10, 16)};
            margin-left: 15px;
            transition: 0.2s;
        }
    }
`;

export const ValueListWrapper = styled.div`
	& + & {
		border-top: 2px solid ${theme.quarterinaryGreen};
		margin-top: ${RelSize(50, 16)};
		padding-top: ${RelSize(50, 16)};
	}	
`;

export const ReadOnly = styled.div`
	background-color: ${theme.white};
  border: 1px solid ${theme.borderGrey};
	background-image: url(${props => props.canEdit ? 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDc3Ljg3MyA0NzcuODczIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzcuODczIDQ3Ny44NzM7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNMzkyLjUzMywyMzguOTM3Yy05LjQyNiwwLTE3LjA2Nyw3LjY0MS0xNy4wNjcsMTcuMDY3VjQyNi42N2MwLDkuNDI2LTcuNjQxLDE3LjA2Ny0xNy4wNjcsMTcuMDY3SDUxLjINCgkJCWMtOS40MjYsMC0xNy4wNjctNy42NDEtMTcuMDY3LTE3LjA2N1Y4NS4zMzdjMC05LjQyNiw3LjY0MS0xNy4wNjcsMTcuMDY3LTE3LjA2N0gyNTZjOS40MjYsMCwxNy4wNjctNy42NDEsMTcuMDY3LTE3LjA2Nw0KCQkJUzI2NS40MjYsMzQuMTM3LDI1NiwzNC4xMzdINTEuMkMyMi45MjMsMzQuMTM3LDAsNTcuMDYsMCw4NS4zMzdWNDI2LjY3YzAsMjguMjc3LDIyLjkyMyw1MS4yLDUxLjIsNTEuMmgzMDcuMg0KCQkJYzI4LjI3NywwLDUxLjItMjIuOTIzLDUxLjItNTEuMlYyNTYuMDAzQzQwOS42LDI0Ni41NzgsNDAxLjk1OSwyMzguOTM3LDM5Mi41MzMsMjM4LjkzN3oiLz4NCgk8L2c+DQo8L2c+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggZD0iTTQ1OC43NDIsMTkuMTQyYy0xMi4yNTQtMTIuMjU2LTI4Ljg3NS0xOS4xNC00Ni4yMDYtMTkuMTM4Yy0xNy4zNDEtMC4wNS0zMy45NzksNi44NDYtNDYuMTk5LDE5LjE0OUwxNDEuNTM0LDI0My45MzcNCgkJCWMtMS44NjUsMS44NzktMy4yNzIsNC4xNjMtNC4xMTMsNi42NzNsLTM0LjEzMywxMDIuNGMtMi45NzksOC45NDMsMS44NTYsMTguNjA3LDEwLjc5OSwyMS41ODUNCgkJCWMxLjczNSwwLjU3OCwzLjU1MiwwLjg3Myw1LjM4LDAuODc1YzEuODMyLTAuMDAzLDMuNjUzLTAuMjk3LDUuMzkzLTAuODdsMTAyLjQtMzQuMTMzYzIuNTE1LTAuODQsNC44LTIuMjU0LDYuNjczLTQuMTMNCgkJCWwyMjQuODAyLTIyNC44MDJDNDg0LjI1LDg2LjAyMyw0ODQuMjUzLDQ0LjY1Nyw0NTguNzQyLDE5LjE0MnogTTQzNC42MDMsODcuNDE5TDIxMi43MzYsMzA5LjI4NmwtNjYuMjg3LDIyLjEzNWwyMi4wNjctNjYuMjAyDQoJCQlMMzkwLjQ2OCw0My4zNTNjMTIuMjAyLTEyLjE3OCwzMS45NjctMTIuMTU4LDQ0LjE0NSwwLjA0NGM1LjgxNyw1LjgyOSw5LjA5NSwxMy43Miw5LjEyLDIxLjk1NQ0KCQkJQzQ0My43NTQsNzMuNjMxLDQ0MC40NjcsODEuNTc1LDQzNC42MDMsODcuNDE5eiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K' : 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMS4yNSAxNSIgd2lkdGg9IjExLjI1IiBoZWlnaHQ9IjE1Ij48dGl0bGU+bG9jay1lZGl0LWljb25fMTwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkNhcGFfMSIgZGF0YS1uYW1lPSJDYXBhIDEiPjxwYXRoIGQ9Ik0xMC45NCw1LjYySDEwVjQuMzdhNC4zOCw0LjM4LDAsMCwwLTguNzUsMFY1LjYySC4zMUEuMzEuMzEsMCwwLDAsMCw1Ljk0djcuODFBMS4yNSwxLjI1LDAsMCwwLDEuMjUsMTVIMTBhMS4yNSwxLjI1LDAsMCwwLDEuMjUtMS4yNVY1Ljk0QS4zMS4zMSwwLDAsMCwxMC45NCw1LjYyWk02LjU2LDEyLjE1YS4zMy4zMywwLDAsMS0uMDguMjUuMzMuMzMsMCwwLDEtLjIzLjFINWEuMzMuMzMsMCwwLDEtLjIzLS4xLjMzLjMzLDAsMCwxLS4wOC0uMjVsLjItMS43N2ExLjIzLDEuMjMsMCwwLDEtLjUxLTEsMS4yNSwxLjI1LDAsMSwxLDIuNSwwLDEuMjQsMS4yNCwwLDAsMS0uNTIsMVpNOC4xMiw1LjYyaC01VjQuMzdhMi41LDIuNSwwLDAsMSw1LDBaIiBzdHlsZT0iZmlsbDojMUMyQzVCIi8+PC9nPjwvZz48L3N2Zz4='});
	background-size: 10px 10px;
	background-position: right 10px top 50%;
	background-repeat: no-repeat;
	/* border-bottom: 2px solid ${theme.black}; */
	color: ${lighten(0.5, theme.black)};
	display: block;
	font-size: 16px;
	line-height: ${RelSize(21, 16)};
	/* max-width: 100%; */
	min-height: ${props => props.large ? RelSize(150, 16) : RelSize(50, 16)};
	overflow: hidden;
	padding: ${props => props.toggle ? RelSize(10, 16) : RelSize(15, 16)};
	padding-right: ${RelSize(25, 16)};
	position: relative;
	text-overflow: ellipsis;
	/* width: 100%; */
	${props => props.clear && `
		background-image: none;
	`}
`;

export const CanEdit = styled.a`
	bottom: 0;
	cursor: pointer;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
`;

export const Note = styled.span`
	display: block;
	font-size: ${RelSize(14, 16)};
	font-style: italic;
	line-height: ${Ratio(14)};
	margin-bottom: ${props => props.pushBottom ? RelSize(20, 14) : RelSize(5, 14)};
	${props => props.help && `
		padding-right: ${RelSize(30, 14)};
		position: relative;
	`}
`;

export const InputError = styled.span`
	background-color: ${lighten(0.4, theme.red)};
	background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iRXhjbHVzaW9uXzUiIGRhdGEtbmFtZT0iRXhjbHVzaW9uIDUiIGQ9Ik0tMjM1Mi0xMDQ3YTkuOTQsOS45NCwwLDAsMS0zLjg5My0uNzg2LDkuOTY0LDkuOTY0LDAsMCwxLTMuMTc4LTIuMTQzLDkuOTYyLDkuOTYyLDAsMCwxLTIuMTQzLTMuMTc5QTkuOTQxLDkuOTQxLDAsMCwxLTIzNjItMTA1N2E5LjkzNyw5LjkzNywwLDAsMSwuNzg2LTMuODkzLDkuOTU4LDkuOTU4LDAsMCwxLDIuMTQzLTMuMTc5LDkuOTY2LDkuOTY2LDAsMCwxLDMuMTc4LTIuMTQzQTkuOTM4LDkuOTM4LDAsMCwxLTIzNTItMTA2N2E5LjkzNiw5LjkzNiwwLDAsMSwzLjg5Mi43ODYsOS45NzIsOS45NzIsMCwwLDEsMy4xNzgsMi4xNDMsOS45NTksOS45NTksMCwwLDEsMi4xNDMsMy4xNzlBOS45MzgsOS45MzgsMCwwLDEtMjM0Mi0xMDU3YTkuOTM2LDkuOTM2LDAsMCwxLS43ODYsMy44OTIsOS45NTksOS45NTksMCwwLDEtMi4xNDMsMy4xNzksOS45NjcsOS45NjcsMCwwLDEtMy4xNzgsMi4xNDNBOS45MzksOS45MzksMCwwLDEtMjM1Mi0xMDQ3Wm0xLjU0MS0xMi40MjloMGwtLjY4OC4xMzNjLS4yNDIuMDQ3LS42NTMuMS0xLjIyMy4xNjhzLTEuMDEuMTA4LTEuMzE3LjEyOXYuNDIyYTIuNzIxLDIuNzIxLDAsMCwxLC43NDIuMWMuMTM1LjA1Mi4yLjE4Ni4yLjRhLjYwNy42MDcsMCwwLDEtLjAxMi4xMTdjLS4wMDguMDQyLS4wMTcuMDgzLS4wMjguMTI1bC0uOTYxLDMuNTk0Yy0uMDc0LjI3LS4xMjguNDgtLjE2NC42NDFhMy4yMTIsMy4yMTIsMCwwLDAtLjA5NC42MTcuOTgxLjk4MSwwLDAsMCwuMzQ3LjgyNCwxLjI1NSwxLjI1NSwwLDAsMCwuNzg1LjI3LDIuMDc5LDIuMDc5LDAsMCwwLDEuNDUzLS42NTYsMTAuOTgsMTAuOTgsMCwwLDAsMS4yLTEuNTQ3bC0uMzUyLS4yMjdhNi4zMDYsNi4zMDYsMCwwLDEtLjYzMy44NjhjLS4yMzkuMjc1LS40NDEuNDE0LS42LjQxNGEuMzEzLjMxMywwLDAsMS0uMTcyLS4wNTFjLS4wNTItLjAzNC0uMDc4LS4xMDktLjA3OC0uMjIzYTQuMjMyLDQuMjMyLDAsMCwxLC4xNDEtLjc1Yy4wMzctLjE1NS4xMS0uNDM2LjIxMS0uODEybDEuMjQyLTQuNTU1Wm0tLjQ0NS0zLjU3MWExLjA1MSwxLjA1MSwwLDAsMC0uNzYyLjMxMiwxLjAzLDEuMDMsMCwwLDAtLjMxNi43NTgsMS4wNDIsMS4wNDIsMCwwLDAsLjMxNi43NjIsMS4wNDQsMS4wNDQsMCwwLDAsLjc2Mi4zMTcsMS4wMywxLjAzLDAsMCwwLC43NTgtLjMxNywxLjA0NywxLjA0NywwLDAsMCwuMzEzLS43NjIsMS4wMzUsMS4wMzUsMCwwLDAtLjMxMi0uNzU4LDEuMDM3LDEuMDM3LDAsMCwwLS43NTUtLjMxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzNjIgMTA2NykiIGZpbGw9IiNlMjMxNDEiLz4KPC9zdmc+Cg==');
	background-size: 20px 20px;
	background-position: 10px 7px;
	background-repeat: no-repeat;
	border: 1px solid ${theme.red};
    color: ${theme.red};
    display: block;
    font-size: ${RelSize(14, 16)};
    font-weight: 400;
    line-height: ${RelSize(16, 14)};
    margin-top: ${RelSize(5, 14)};
	padding: ${RelSize(10, 14)} ${RelSize(10, 14)} ${RelSize(10, 14)} ${RelSize(40, 14)};
    position: relative;
`;

export const InputWarning = styled.span`
	background-color: ${lighten(0.4, theme.trafficLightAmber)};
	background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iRXhjbHVzaW9uXzUiIGRhdGEtbmFtZT0iRXhjbHVzaW9uIDUiIGQ9Ik0tMjM1Mi0xMDQ3YTkuOTQsOS45NCwwLDAsMS0zLjg5My0uNzg2LDkuOTY0LDkuOTY0LDAsMCwxLTMuMTc4LTIuMTQzLDkuOTYyLDkuOTYyLDAsMCwxLTIuMTQzLTMuMTc5QTkuOTQxLDkuOTQxLDAsMCwxLTIzNjItMTA1N2E5LjkzNyw5LjkzNywwLDAsMSwuNzg2LTMuODkzLDkuOTU4LDkuOTU4LDAsMCwxLDIuMTQzLTMuMTc5LDkuOTY2LDkuOTY2LDAsMCwxLDMuMTc4LTIuMTQzQTkuOTM4LDkuOTM4LDAsMCwxLTIzNTItMTA2N2E5LjkzNiw5LjkzNiwwLDAsMSwzLjg5Mi43ODYsOS45NzIsOS45NzIsMCwwLDEsMy4xNzgsMi4xNDMsOS45NTksOS45NTksMCwwLDEsMi4xNDMsMy4xNzlBOS45MzgsOS45MzgsMCwwLDEtMjM0Mi0xMDU3YTkuOTM2LDkuOTM2LDAsMCwxLS43ODYsMy44OTIsOS45NTksOS45NTksMCwwLDEtMi4xNDMsMy4xNzksOS45NjcsOS45NjcsMCwwLDEtMy4xNzgsMi4xNDNBOS45MzksOS45MzksMCwwLDEtMjM1Mi0xMDQ3Wm0xLjU0MS0xMi40MjloMGwtLjY4OC4xMzNjLS4yNDIuMDQ3LS42NTMuMS0xLjIyMy4xNjhzLTEuMDEuMTA4LTEuMzE3LjEyOXYuNDIyYTIuNzIxLDIuNzIxLDAsMCwxLC43NDIuMWMuMTM1LjA1Mi4yLjE4Ni4yLjRhLjYwNy42MDcsMCwwLDEtLjAxMi4xMTdjLS4wMDguMDQyLS4wMTcuMDgzLS4wMjguMTI1bC0uOTYxLDMuNTk0Yy0uMDc0LjI3LS4xMjguNDgtLjE2NC42NDFhMy4yMTIsMy4yMTIsMCwwLDAtLjA5NC42MTcuOTgxLjk4MSwwLDAsMCwuMzQ3LjgyNCwxLjI1NSwxLjI1NSwwLDAsMCwuNzg1LjI3LDIuMDc5LDIuMDc5LDAsMCwwLDEuNDUzLS42NTYsMTAuOTgsMTAuOTgsMCwwLDAsMS4yLTEuNTQ3bC0uMzUyLS4yMjdhNi4zMDYsNi4zMDYsMCwwLDEtLjYzMy44NjhjLS4yMzkuMjc1LS40NDEuNDE0LS42LjQxNGEuMzEzLjMxMywwLDAsMS0uMTcyLS4wNTFjLS4wNTItLjAzNC0uMDc4LS4xMDktLjA3OC0uMjIzYTQuMjMyLDQuMjMyLDAsMCwxLC4xNDEtLjc1Yy4wMzctLjE1NS4xMS0uNDM2LjIxMS0uODEybDEuMjQyLTQuNTU1Wm0tLjQ0NS0zLjU3MWExLjA1MSwxLjA1MSwwLDAsMC0uNzYyLjMxMiwxLjAzLDEuMDMsMCwwLDAtLjMxNi43NTgsMS4wNDIsMS4wNDIsMCwwLDAsLjMxNi43NjIsMS4wNDQsMS4wNDQsMCwwLDAsLjc2Mi4zMTcsMS4wMywxLjAzLDAsMCwwLC43NTgtLjMxNywxLjA0NywxLjA0NywwLDAsMCwuMzEzLS43NjIsMS4wMzUsMS4wMzUsMCwwLDAtLjMxMi0uNzU4LDEuMDM3LDEuMDM3LDAsMCwwLS43NTUtLjMxMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzNjIgMTA2NykiIGZpbGw9IiNlMjMxNDEiLz4KPC9zdmc+Cg==');
	background-size: 20px 20px;
	background-position: 10px 7px;
	background-repeat: no-repeat;
	border: 1px solid ${theme.trafficLightAmber};
    color: ${theme.black};
    display: block;
    font-size: ${RelSize(14, 16)};
    font-weight: 400;
    line-height: ${RelSize(16, 14)};
    margin-top: ${RelSize(5, 14)};
	padding: ${RelSize(10, 14)} ${RelSize(10, 14)} ${RelSize(10, 14)} ${RelSize(40, 14)};
    position: relative;
	${({ pushBottom }) => pushBottom && `
		margin-bottom: ${RelSize(20, 14)};
	`}
`;

export const SimpleSelect = styled.select`
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: ${props => props.light ? theme.white : "transparent"};
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICA8cGF0aCBpZD0iUG9seWdvbl8xIiBkYXRhLW5hbWU9IlBvbHlnb24gMSIgZD0iTTUsMGw1LDEwSDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCAxMCkgcm90YXRlKDE4MCkiIGZpbGw9IiMxYzJjNWIiLz4KPC9zdmc+Cg==');
    background-size: 10px 10px;
    background-position: 98% 50%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    border: 1px solid ${theme.black};
    border-radius: 0;
    display: block;
    font-size: ${RelSize(16, 16)};
    padding: ${props => props.small ? RelSize(10, 16) : RelSize(10, 16)} ${props => props.small ? RelSize(40, 16) : RelSize(50, 16)} ${props => props.small ? RelSize(10, 16) : RelSize(10, 16)} ${props => props.small ? RelSize(10, 16) : RelSize(10, 16)};
    width: 100%;
    &:focus {
        outline: none;
    }
    option {
        font-weight: normal;
    }
`;

export const SearchSelectWrapper = styled.div`
    position: relative;
`;

export const SearchSelect = styled.div`
	background-color: ${theme.white};
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICA8cGF0aCBpZD0iUG9seWdvbl8xIiBkYXRhLW5hbWU9IlBvbHlnb24gMSIgZD0iTTUsMGw1LDEwSDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMCAxMCkgcm90YXRlKDE4MCkiIGZpbGw9IiMxYzJjNWIiLz4KPC9zdmc+Cg==');
    background-size: 10px 10px;
    background-position: right 10px center;
    background-repeat: no-repeat;
    box-sizing: border-box;
    border: 1px solid ${props => props.error ? props.theme.red : props.theme.borderGrey};
    border-radius: 0;
    cursor: pointer;
    display: block;
    font-size: ${RelSize(16, 16)};
    padding: ${props => props.small ? RelSize(10, 16) : RelSize(15, 16)} ${props => props.small ? RelSize(40, 16) : RelSize(30, 16)} ${props => props.small ? RelSize(10, 16) : RelSize(15, 16)} ${props => props.small ? RelSize(10, 16) : RelSize(15, 16)};
    position: relative;
    width: 100%;
	span {
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		// padding-right: 20px;
		white-space: nowrap;
		width: 100%;
	}
	@media all and (min-width: 1025px) {
		min-width: ${RelSize(150, 16)};
	}
	${({ open }) => open && `
		background-image: none;
	`}
`;

export const SelectOptions = styled.div`
    background-color: ${theme.white};
    border: 1px solid ${props => props.theme.borderGrey};
	box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
    border-top: 0;
    max-height: ${RelSize(200, 16)};
    overflow-y: auto;
    z-index: 999;
	scrollbar-width: thin;
	scrollbar-color: ${theme.primaryGreen} transparent;
	&::-webkit-scrollbar {
	  width: 5px;
	}
	&::-webkit-scrollbar-track {
	  background: transparent;
	}
	&::-webkit-scrollbar-thumb {
	  background: ${theme.primaryGreen};
	}
	${props => !props.grow && `
		left: 0;
		position: absolute;
		right: 0;
		top: 100%;
	`}
	${props => props.open && `
		left: auto;
		max-height: ${RelSize(300, 16)};
		position: relative;
		right: auto;
	`}
`;

export const SelectOption = styled.div`
    cursor: ${props => props.inactive ? "default" : "pointer"};
    font-size: ${props => props.small ? RelSize(12, 16) : RelSize(14, 16)};
    padding: ${props => props.small ? RelSize(10, 12) : RelSize(10, 16)} ${props => props.small ? RelSize(30, 12) : RelSize(40, 16)} ${props => props.small ? RelSize(10, 12) : RelSize(10, 16)} ${props => props.small ? RelSize(10, 12) : RelSize(10, 16)};
    position: relative;
    ${props => !props.hideActive && !props.inactive && `
		&::after {
			background-color: ${props.active ? props.external ? theme.quarterinaryGreen : theme.quarterinaryGreen : "transparent"};
			border-radius: 50%;
			border: 2px solid ${theme.primaryGreen};
			content: "";
			height: 15px;
			position: absolute;
			right: 15px;
			top: 50%;
			transform: translateY(-50%);
			width: 15px;
		}
	`};
	${props => props.inactive && `
		span {
			opacity: 0.25;
		}
		div {
			height: 15px;
			position: absolute;
			right: 15px;
			top: 50%;
			transform: translateY(-50%);
			width: 15px;
		}
	`};
	${props => props.showIcon && `
		div {
			height: 15px;
			position: absolute;
			right: 45px;
			top: 50%;
			transform: translateY(-50%);
			width: 15px;
		}
	`};
	${props => props.booking && `
		a {
			height: 15px;
			position: absolute;
			right: 45px;
			top: 50%;
			transform: translateY(-50%);
			width: 15px;
		}
	`};
`;

export const SelectOptionDocumentItem = styled.span`
	align-items: center;
    display: flex;
	i {
		margin-right: ${RelSize(10, 14)};
	}
`;

export const SelectSearchField = styled.div`
    input {
        border: 0;
        border-bottom: 2px solid ${theme.black};
        padding: ${props => props.small ? RelSize(10, 12) : RelSize(10, 16)};
    }
	${(filter) => filter && `
		input {
			padding: 5px 8px !important;
		}
	`}
`;

export const SelectClear = styled.div`
    a {
		cursor: pointer;
		display: block;
		font-size: ${props => props.small ? RelSize(12, 16) : RelSize(14, 16)};
		padding: ${props => props.small ? RelSize(10, 12) : RelSize(10, 16)};
		text-align: right;
	}
`;

export const FileWrapper = styled.div`
    position: relative;
	${props => props.minHeight && `
		min-height: ${RelSize(50, 16)};
	`}
`;

export const FileTrigger = styled.div`
    align-items: center;
	background-color: ${theme.white};
    border: 1px solid ${props => props.external ? theme.black : theme.borderGrey};
    bottom: 0;
    color: ${theme.black};
    cursor: pointer;
    display: flex;
	height: ${RelSize(50, 16)};
    font-size: ${RelSize(16, 16)};
    left: 0;
    line-height: ${RelSize(16, 16)};
    margin: 0;
    max-width: 100%;
    overflow: hidden;
    padding: ${RelSize(10, 16)} ${RelSize(110, 16)} ${RelSize(10, 16)} ${RelSize(10, 16)};
    position: absolute;
    right: 0;
    text-overflow: ellipsis;
    transition: all ease-in 0.2s;
    top: 0;
    white-space: nowrap;
    /* z-index: -1; */
    ${props => !props.readonly && `
		pointer-events: none;
        &::after {
            align-items: center;
            background-color: ${props.external ? theme.primaryGreen : theme.primaryGreen};
            bottom: 0;
            content: "Select File";
            color: ${props.theme.white};
            display: flex;
            padding: ${RelSize(15, 16)};
            position: absolute;
            right: 0;
            top: 0;
        }
    `}
`;

export const ProfilePhotoFileTrigger = styled.div`
    align-items: center;
	background-color: ${theme.white};
    border: 1px solid ${theme.black};
    bottom: 0;
    color: ${theme.black};
    cursor: pointer;
    display: flex;
	height: ${RelSize(50, 16)};
    font-size: ${RelSize(16, 16)};
    left: 0;
    line-height: ${RelSize(16, 16)};
    margin: 0;
    max-width: 100%;
    overflow: hidden;
    padding: ${RelSize(10, 16)} ${RelSize(110, 16)} ${RelSize(10, 16)} ${RelSize(10, 16)};
    position: absolute;
    right: 0;
    text-overflow: ellipsis;
    transition: all ease-in 0.2s;
    top: 0;
    white-space: nowrap;
    /* z-index: -1; */
    ${props => !props.readonly && `
        &::after {
            align-items: center;
            background-color: ${theme.primaryGreen};
            bottom: 0;
            content: "Capture Photo";
            color: ${props.theme.white};
            display: flex;
            padding: ${RelSize(15, 16)};
            position: absolute;
            right: 0;
            top: 0;
        }
    `}
`;

export const ProfilePhotoCaptureButtonWrapper = styled.div`
	bottom: 0;
	left: 0;
	padding: ${RelSize(10, 16)};
	position: absolute;
	width: 100%;
`;

export const SilhouetteOverlayWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
`;

export const SilhouetteOverlay = styled.div`
	height: 100%;
	overflow: hidden;
	position: relative;
	width: 100%;
	svg {
		position: absolute;
		width: 100%;
		height: auto;
		top: 0;
		left: 0;
		transform: translateY(10%);
	}
`;

export const ImagePreview = styled.div`
    border: 1px solid ${theme.borderGrey};
	padding: ${RelSize(10, 16)};
	span {
		display: block;
		font-size: ${RelSize(14, 16)};
	}
	img {
		display: block;
		width: 100%;
	}
	a {
		color: ${props => props.theme.primaryGreen};
		display: inline-block;
		font-size: ${RelSize(12, 16)};
		margin-top: ${RelSize(10, 12)};
	}
`;

export const ImageCropWrapper = styled.div`
	background-color: ${theme.borderGrey};
    display: block;
	margin: 0 auto;
	text-align: center;
`;

export const FileList = styled.div`
	p {
		font-size: ${RelSize(14, 16)};
		line-height: ${Ratio(14)};
		margin: 0;
	}
`;

export const ToggleWrapper = styled.div`
    align-items: center;
    display: flex;
    margin-bottom: ${props => props.pushBottom ? RelSize(20, 16) : 0};
    background-color: ${theme.white};
    padding: ${props => props.readOnly ? RelSize(5, 16) : RelSize(10, 16)};
`;

export const ToggleItem = styled.div`
	font-size: ${props => props.small ? RelSize(12, 16) : RelSize(16, 16)};
	${props => props.help && `
		padding-right: ${RelSize(25, 16)};
		position: relative;
	`}
    input {
        display: none;
        &:checked {
            ~ label {
                &::after {
                    color: ${theme.primaryGreen};
                    content: "\2713";
                    left: 0;
                    position: absolute;
                    top: 0;
                }
            }
        }
        &:checked {
            ~ label {
                &::after {
                    color: ${theme.primaryGreen};
                    content: "L";
                    font-size: ${RelSize(20, 16)};
                    left: ${RelSize(15, 20)};
                    position: absolute;
                    top: ${RelSize(14, 20)};
                    transform: translate(-50%, -50%) rotate(45deg) scale(-1, 1);
                }
            }
        }
        &[disabled] {
            &:checked {
                ~ label {
                    &::after {
                        color: ${theme.lightGreyText};
                    }
                }
            }
        }
    }
    label {
		color: ${theme.primaryGreen};
        cursor: pointer;
        display: block;
		font-weight: 700;
        line-height: ${RelSize(20, 16)};
		padding-bottom: ${RelSize(5, 16)};
        padding-left: ${RelSize(40, 16)};
		padding-top: ${RelSize(5, 16)};
        position: relative;
        &::before {
            border: 2px solid ${theme.quarterinaryGreen};
            content: "";
            height: ${RelSize(30, 16)};
            left: 0;
            position: absolute;
            top: 0;
            width: ${RelSize(30, 16)};
        }
    }
    &:not(:last-child) {
        margin-right: ${RelSize(20, 16)};
    }
`;

export const ToggleDesc = styled.span`
	display: block;
	font-size: ${RelSize(10, 16)};
	margin: ${RelSize(10, 10)} 0 ${RelSize(20, 10)} 0;
`;

export const ColorPicker = styled.div`
	position: relative;
`;

export const ColorPickerTrigger = styled.div`
	border: 1px solid ${theme.borderGrey};
	position: relative;
	width: 100%;
	> a {
		display: block;
		font-size: ${RelSize(14, 16)};
		line-height: ${RelSize(21, 14)};
        padding: ${RelSize(15, 14)} ${RelSize(15, 14)} ${RelSize(20, 14)};
		position: relative;
		${props => props.color && `
			&::after {
				background-color: ${props.color};
				bottom: 0;
				content: "";
				height: 10px;
				left: 0;
				position: absolute;
				right: 0;
				z-index: 1;
			}
		`}
	}
`;

export const ColorPickerWrapper = styled.div`
	position: absolute;
	width: 100%;
	z-index: 2;
`;

export const HelpWrapperStyled = styled.a`
	align-items: center;
	background-color: ${props => props.error ? theme.red : theme.primaryGreen};
	border-radius: 50%;
	display: flex;
	height: ${RelSize(20, 16)};
	justify-content: center;
	width: ${RelSize(20, 16)};
	${props => !props.header ? `
		position: absolute;
		right: 0;
		top: ${RelSize(2, 16)};
	` : `
		margin-right: ${RelSize(10, 16)};
		width: ${RelSize(20, 16)};
	`}
	i {
		display: block;
		height: ${RelSize(12, 16)};
		width: ${RelSize(7, 16)};
		svg, img {
			display: block;
			height: 100%;
			width: 100%;
		}
	}
`;

export const ChartHelpWrapperStyled = styled.a`
	align-items: center;
	background-color: ${props => props.type === "error" ? theme.red : props.type === "warning" ? theme.amber : theme.primaryGreen};
	border-radius: 50%;
	display: flex;
	height: ${RelSize(20, 16)};
	justify-content: center;
	left: ${RelSize(5, 16)};
	position: absolute;
	top: ${RelSize(5, 16)};
	width: ${RelSize(20, 16)};
	i {
		display: block;
		height: ${RelSize(12, 16)};
		width: ${RelSize(7, 16)};
		svg, img {
			display: block;
			height: 100%;
			width: 100%;
		}
	}
`;

export const DatePickerWrapper = styled.div`
    display: block;
    ${props => props.minimumHeight && `
		min-height: 300px
	`}
    .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  margin-left: -8px;
  position: absolute;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: #f0f0f0;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  bottom: 0;
  margin-bottom: -8px;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  border-bottom: none;
  border-top-color: #fff;
}

.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before {
  bottom: -1px;
  border-top-color: #aeaeae;
}

.react-datepicker-wrapper {
  display: block;
  padding: 0;
  border: 0;
}
    .react-datepicker {
        font-size: 0.8rem;
        background-color: #fff;
        color: ${theme.black};
        border: 1px solid ${theme.primaryGreen};
		border-radius: 0;
        display: inline-block;
        position: relative;
        width: 100%;
    }
    .react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}

.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}

.react-datepicker--time-only .react-datepicker__time, .react-datepicker--time-only .react-datepicker__time-box {
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 1;
}

.react-datepicker-popper[data-placement^="bottom"] {
  margin-top: 10px;
}

.react-datepicker-popper[data-placement="bottom-end"] .react-datepicker__triangle, .react-datepicker-popper[data-placement="top-end"] .react-datepicker__triangle {
  left: auto;
  right: 50px;
}

.react-datepicker-popper[data-placement^="top"] {
  margin-bottom: 10px;
}

.react-datepicker-popper[data-placement^="right"] {
  margin-left: 8px;
}

.react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}

.react-datepicker-popper[data-placement^="left"] {
  margin-right: 8px;
}

.react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: ${theme.white};
  border-bottom: 1px solid ${theme.black};
  padding-top: ${RelSize(20, 16)};
  position: relative;
  width: 100%;
}

.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__header--time:not(.react-datepicker__header--time--only) {
  border-top-left-radius: 0;
}

.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
  color: #000;
  font-weight: bold;
  font-size: 0.944rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  line-height: 1.7rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 17px;
  width: 0;
  padding: 0;
  border: 0.45rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
}

.react-datepicker__navigation--previous {
  left: 10px;
  border-right-color: ${theme.quarterinaryGreen};
}

.react-datepicker__navigation--previous:hover, .react-datepicker__navigation--previous:active, .react-datepicker__navigation--previous:focus {
  border-right-color: ${theme.quarterinaryGreen};
  outline: none;
}

.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: #e6e6e6;
  cursor: not-allowed;
}

.react-datepicker__navigation--next {
  right: 10px;
  border-left-color: ${theme.quarterinaryGreen};
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 95px;
}

.react-datepicker__navigation--next:hover, .react-datepicker__navigation--next:active, .react-datepicker__navigation--next:focus {
  border-left-color: ${theme.quarterinaryGreen};
  outline: none;
}

.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {
  border-left-color: #e6e6e6;
  cursor: not-allowed;
}

.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ccc;
}

.react-datepicker__navigation--years-previous:hover {
  border-top-color: #b3b3b3;
}

.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ccc;
}

.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: #b3b3b3;
}

.react-datepicker__month-container {
  float: left;
  width: 100%;
}

.react-datepicker__year {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__year-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 180px;
}

.react-datepicker__year .react-datepicker__year-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__input-time-container {
  clear: both;
  width: 100%;
  float: left;
  margin: 5px 0 10px 15px;
  text-align: left;
}

.react-datepicker__input-time-container .react-datepicker-time__caption {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  display: inline-block;
  margin-left: 10px;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: 85px;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-inner-spin-button,
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"] {
  -moz-appearance: textfield;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
  margin-left: 5px;
  display: inline-block;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #aeaeae;
  width: 85px;
}

.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -72px;
  top: 0;
}

.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 85px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + (1.7rem / 2));
  overflow-y: scroll;
  padding-right: 0px;
  padding-left: 0px;
  width: 100%;
  box-sizing: content-box;
  scrollbar-width: thin;
	scrollbar-color: ${theme.primaryGreen} transparent;
	&::-webkit-scrollbar {
	  width: 5px;
	}
	&::-webkit-scrollbar-track {
	  background: transparent;
	}
	&::-webkit-scrollbar-thumb {
	  background: ${theme.primaryGreen};
	}
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 30px;
  padding: 5px 10px;
  white-space: nowrap;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #216ba5;
  color: white;
  font-weight: bold;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #216ba5;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ccc;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #000;
  display: inline-block;
  width: 1.6rem;
  line-height: 1.6rem;
  text-align: center;
  margin: 2px;
}

.react-datepicker__day-name {
	font-weight: bold;
}

.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,
.react-datepicker__quarter--selected,
.react-datepicker__quarter--in-selecting-range,
.react-datepicker__quarter--in-range {
  border-radius: 0.3rem;
  background-color: #216ba5;
  color: #fff;
}

.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,
.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter--in-selecting-range:hover,
.react-datepicker__quarter--in-range:hover {
  background-color: #1d5d90;
}

.react-datepicker__month--disabled,
.react-datepicker__quarter--disabled {
  color: #ccc;
  pointer-events: none;
}

.react-datepicker__month--disabled:hover,
.react-datepicker__quarter--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor: pointer;
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  background-color: ${theme.white};
}

.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
  font-weight: bold;
}

.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted,
.react-datepicker__quarter-text--highlighted,
.react-datepicker__year-text--highlighted {
  background-color: ${theme.primaryGreen};
  color: ${theme.white};
}

.react-datepicker__day--highlighted:hover,
.react-datepicker__month-text--highlighted:hover,
.react-datepicker__quarter-text--highlighted:hover,
.react-datepicker__year-text--highlighted:hover {
  background-color: ${theme.primaryGreen};
}

.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1,
.react-datepicker__quarter-text--highlighted-custom-1,
.react-datepicker__year-text--highlighted-custom-1 {
  color: magenta;
}

.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2,
.react-datepicker__quarter-text--highlighted-custom-2,
.react-datepicker__year-text--highlighted-custom-2 {
  color: green;
}

.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  background-color: ${theme.primaryGreen};
  color: #fff;
}

.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
  background-color: ${theme.primaryGreen};
}

/* .react-datepicker__day--keyboard-selected, */
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: ${theme.primaryGreen};
  color: #fff;
}

/* .react-datepicker__day--keyboard-selected:hover, */
.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover,
.react-datepicker__year-text--keyboard-selected:hover {
  background-color: ${theme.primaryGreen};
}

.react-datepicker__day--in-selecting-range ,
.react-datepicker__month-text--in-selecting-range ,
.react-datepicker__quarter-text--in-selecting-range ,
.react-datepicker__year-text--in-selecting-range {
  background-color: rgba(28,44,91,.7);
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range , .react-datepicker__month--selecting-range
.react-datepicker__month-text--in-range , .react-datepicker__month--selecting-range
.react-datepicker__quarter-text--in-range , .react-datepicker__month--selecting-range
.react-datepicker__year-text--in-range {
  background-color: ${theme.white};
  color: ${theme.black};
}

.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
  background-color: transparent;
  cursor: not-allowed;
  color: #ccc;
}

.react-datepicker__day--disabled:hover,
.react-datepicker__month-text--disabled:hover,
.react-datepicker__quarter-text--disabled:hover,
.react-datepicker__year-text--disabled:hover {
  background-color: transparent;
}

.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__month--selected:hover,
.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
  background-color: ${theme.primaryGreen};
}

.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover {
  background-color: ${theme.white};
}

.react-datepicker__input-container {
  position: relative;
  display: block;
  width: 100%;
  > input {
	background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48IS0tIFVwbG9hZGVkIHRvOiBTVkcgUmVwbywgd3d3LnN2Z3JlcG8uY29tLCBHZW5lcmF0b3I6IFNWRyBSZXBvIE1peGVyIFRvb2xzIC0tPg0KPHN2ZyBmaWxsPSIjMDAwMDAwIiB3aWR0aD0iODAwcHgiIGhlaWdodD0iODAwcHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMywyMkgyMWExLDEsMCwwLDAsMS0xVjZhMSwxLDAsMCwwLTEtMUgxN1YzYTEsMSwwLDAsMC0yLDBWNUg5VjNBMSwxLDAsMCwwLDcsM1Y1SDNBMSwxLDAsMCwwLDIsNlYyMUExLDEsMCwwLDAsMywyMlpNNCw3SDIwdjNINFptMCw1SDIwdjhINFoiLz48L3N2Zz4=');
	background-size: 15px 15px;
	background-position: right 10px top 50%;
	background-repeat: no-repeat;
	padding-right: ${RelSize(40, 16)};
  }
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}

.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #ccc;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.45rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}

.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}

.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
  scrollbar-width: thin;
	scrollbar-color: ${theme.primaryGreen} transparent;
	&::-webkit-scrollbar {
	  width: 5px;
	}
	&::-webkit-scrollbar-track {
	  background: transparent;
	}
	&::-webkit-scrollbar-thumb {
	  background: ${theme.primaryGreen};
	}
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ccc;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #b3b3b3;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0px 6px 0px 0px;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}

.react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 1px solid #aeaeae;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}

.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}

@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 1.5rem;
    line-height: 1.5rem;
  }
}

.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

.react-datepicker__portal .react-datepicker__navigation {
  border: 0.81rem solid transparent;
}

.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: ${theme.primaryGreen};;
}

.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: ${theme.primaryGreen};;
}

.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: #e6e6e6;
  cursor: not-allowed;
}

.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: ${theme.primaryGreen};
}

.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: ${theme.primaryGreen};;
}

.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
  border-left-color: #e6e6e6;
  cursor: not-allowed;
}

/* DayPicker styles */

.DayPicker {
	border: 1px solid ${theme.borderGrey};
  display: inline-block;
  font-size: 1rem;
}

.DayPicker-wrapper {
background-color: ${theme.white};
border: 1px solid ${theme.white};
  position: relative;

  flex-direction: row;

  -webkit-user-select: none;

     -moz-user-select: none;

      -ms-user-select: none;

          user-select: none;
}

.DayPicker-Months {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.DayPicker-Month {
  display: table;
  /* margin: 0 1em; */
  margin-top: 1em;
  border-spacing: 0;
  border-collapse: collapse;

  -webkit-user-select: none;

     -moz-user-select: none;

      -ms-user-select: none;

          user-select: none;
}

.DayPicker-NavBar {
}

.DayPicker-NavButton {
  position: absolute;
  top: ${RelSize(12, 16)};
  right: ${RelSize(5, 16)};
  left: auto;

  display: inline-block;
  width: ${RelSize(25, 16)};
  height: ${RelSize(25, 16)};
  background-position: center;
  background-size: 50%;
  background-repeat: no-repeat;
  color: #8B9898;
  cursor: pointer;
}

.DayPicker-NavButton:hover {
  opacity: 0.8;
}

.DayPicker-NavButton--prev {
  margin-right: 1.5em;
  background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDkwLjY2MSA0OTAuNjYxIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OTAuNjYxIDQ5MC42NjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNDUzLjMzMSwxLjQyNGMtMy4zMDctMS44OTktNy4zODEtMS44OTktMTAuNjg4LDBMMzcuMzA5LDIzNi4wOTFjLTMuMjg1LDEuOTItNS4zMTIsNS40NC01LjMxMiw5LjIzNw0KCQkJczIuMDI3LDcuMzE3LDUuMzEyLDkuMjM3bDQwNS4zMzMsMjM0LjY2N2MxLjY2NCwwLjk2LDMuNDk5LDEuNDI5LDUuMzU1LDEuNDI5YzEuODM1LDAsMy42OTEtMC40NjksNS4zMzMtMS40MjkNCgkJCWMzLjI4NS0xLjg5OSw1LjMzMy01LjQxOSw1LjMzMy05LjIzN1YxMC42NjFDNDU4LjY2NCw2Ljg0Myw0NTYuNjE2LDMuMzIzLDQ1My4zMzEsMS40MjR6IiBmaWxsPSIjMUMyQzVCIi8+DQoJPC9nPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPC9zdmc+DQo=');

}

.DayPicker-NavButton--next {
  background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNDkwLjY2MSA0OTAuNjYxIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OTAuNjYxIDQ5MC42NjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNDUzLjM1MiwyMzYuMDkxTDQ4LjAxOSwxLjQyNGMtMy4yODUtMS44OTktNy4zNi0xLjg5OS0xMC42ODgsMGMtMy4yODUsMS44OTktNS4zMzMsNS40MTktNS4zMzMsOS4yMzd2NDY5LjMzMw0KCQkJYzAsMy44MTksMi4wNDgsNy4zMzksNS4zMzMsOS4yMzdjMS42NDMsMC45MzksMy40OTksMS40MjksNS4zMzMsMS40MjljMS44NTYsMCwzLjY5MS0wLjQ2OSw1LjM1NS0xLjQyOWw0MDUuMzMzLTIzNC42NjcNCgkJCWMzLjI4NS0xLjkyLDUuMzEyLTUuNDQsNS4zMTItOS4yMzdTNDU2LjYzNywyMzcuOTg5LDQ1My4zNTIsMjM2LjA5MXoiLz4NCgk8L2c+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg==');
}

.DayPicker-NavButton--interactionDisabled {
  display: none;
}

.DayPicker-Caption {
		color: ${theme.primaryGreen};
  display: table-caption;
  margin-bottom: 0.5em;
  padding: 0 ${RelSize(10, 16)} ${RelSize(15, 16)};
  text-align: left;
  border-bottom: 2px solid ${theme.borderGrey};
}

.DayPicker-Caption > div {
  font-weight: 500;
  font-size: ${RelSize(14, 16)};
}

.DayPicker-Weekdays {
  display: table-header-group;
  margin-top: 1em;
}

.DayPicker-WeekdaysRow {
  display: table-row;
}

.DayPicker-Weekday {
  display: table-cell;
  padding: 0.5em;
  color: #8B9898;
  text-align: center;
  font-size: 0.875em;
}

.DayPicker-Weekday abbr[title] {
  border-bottom: none;
  text-decoration: none;
}

.DayPicker-Body {
  display: table-row-group;
}

.DayPicker-Week {
  display: table-row;
}

.DayPicker-Day {
  display: table-cell;
  padding: 0.5em;
  border-radius: 0;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
}

.DayPicker-WeekNumber {
  display: table-cell;
  padding: 0.5em;
  min-width: 1em;
  border-right: 1px solid #EAECEC;
  color: #8B9898;
  vertical-align: middle;
  text-align: right;
  font-size: 0.75em;
  cursor: pointer;
}

.DayPicker--interactionDisabled .DayPicker-Day {
  cursor: default;
}

.DayPicker-Footer {
  padding-top: 0.5em;
}

.DayPicker-TodayButton {
  border: none;
  background-color: transparent;
  background-image: none;
  box-shadow: none;
  color: #4A90E2;
  font-size: 0.875em;
  cursor: pointer;
}

/* Default modifiers */

.DayPicker-Day--today {
	color: ${theme.quarterinaryGreen};
}

.DayPicker-Day--outside {
  color: #8B9898;
  cursor: default;
}

.DayPicker-Day--disabled {
  color: #DCE0E0;
  cursor: default;
  /* background-color: #eff1f1; */
}

/* Example modifiers */

.DayPicker-Day--sunday {
  background-color: #F7F8F8;
}

.DayPicker-Day--sunday:not(.DayPicker-Day--today) {
  color: #DCE0E0;
}

.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
  position: relative;

  background-color: ${theme.quarterinaryGreen};
  color: #F0F8FF;
}

.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
  background-color: ${darken(0.1, theme.quarterinaryGreen)};
}

.DayPicker:not(.DayPicker--interactionDisabled)
  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
  background-color: ${theme.secondaryBackgroundGrey};
}

/* DayPickerInput */

.DayPickerInput {
  display: inline-block;
}

.DayPickerInput-OverlayWrapper {
  position: relative;
}

.DayPickerInput-Overlay {
  position: absolute;
  left: 0;
  z-index: 1;

  background: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.react-datepicker__header__dropdown--select {
	display: flex;
	justify-content: space-between;
	padding: 5px;
	select {
		box-shadow: 0;
		border: 1px solid ${theme.primaryGreen};
	}
}

.react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
	background-color: ${theme.borderGrey};
}


`;

export const GeoSearch = styled.div`
	form {
		margin: 0;
		padding: 0;
		@media all and (min-width: 768px) {
			align-items: center;
			display: flex;
		}
	}
	label {
		font-size: ${RelSize(14, 16)};
		margin-right: ${RelSize(10, 14)};
	}
	input {
		background-color: ${lighten(0.01, theme.backgroundGrey)};
		border: 1px solid ${theme.backgroundGrey};
		border-radius: 0;
		box-shadow: 0;
		display: block;
		font-size: 14px;
		line-height: 18px;
		padding: 5px;
		width: 100%;
		&:active, &:focus {
			border: 1px solid ${theme.primaryGreen};
			outline: none;
		}
		@media all and (min-width: 768px) {
			width: 250px;
		}
	}
	.candidateRadiusAutocompleteClear {
		font-size: ${RelSize(12, 16)};
		margin-left: ${RelSize(10, 12)};
	}
`;